import _ from 'lodash';
import { mapState } from 'vuex';
import { customer, SearchTable } from '~';

const endpoint = customer.endpoint;
const enabledFields = customer.enabledFields;
const availableFilters = customer.availableFilters;
const enabledFieldsSM = customer.enabledFieldsSM;
const enabledFieldsMD = customer.enabledFieldsMD;

export default {
  components: {
    'search-table': SearchTable,
  },
  computed: {
    ...mapState('publicConfig', ['config']),
    disabledFields() {
      return _.get(this.config, 'disabled_columns.lab.customers', []);
    },
    options() {
      const availableFields = customer.availableFields(this.disabledFields);

      return {
        endpoint,
        fields: availableFields,
        enabledFields,
        enabledFieldsSM,
        enabledFieldsMD,
        availableFilters,
        enabledFilters: [],
      };
    },
  },
  methods: {
    openItemUrl(item) {
      return { name: 'customer', params: { id: item.id } };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/customers/Customers.js